<template>
  <!-- header START -->
 <div class="ft">
    
    <div class="ft-1" v-if="$store.state.jackpotlast">
      <div>{{$t('lastjack')}}</div>
      <div>{{$store.state.jackpotlast.Amount.toFixed(2)}}</div>
    </div>
    
    <div class="ft-2">
      <div>
        {{date}}
      </div>
      <div></div>
    </div>

    <div class="leaguetv" v-if="$store.state.game">
      <div>{{$t('league')}}</div>
      <div>{{getleage().league}}</div>
    </div>

    <div class="weektv" v-if="$store.state.game">
      <div>{{$t('week')}}</div>
      <div>{{getleage().week}}</div>
    </div>

    <div class="fl-col2">
      <div :class="animationclass" v-if="$store.state.gameresults"><!-- для движения добавляй скриптом сдвиг в этот стиль style="left: -100px" -->
        <div class="ft-3" v-for="item in $store.state.gameresults.slice(0, 10)">
          <div class="td"></div>
          <div class="td" v-if="$store.state.teams">
            <div class="icon"><img :src="getimg(item.HomeTeam)" alt=""></div>
          </div>
          <div class="td" v-if="$store.state.teams">{{getteams(item.HomeTeam)}}</div>
          <div class="td">{{item.Result}}</div>
          <div class="td" v-if="$store.state.teams">{{getteams(item.AwayTeam)}}</div>
          <div class="td" v-if="$store.state.teams">
            <div class="icon"><img :src="getimg(item.AwayTeam)" alt=""></div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- header STOP -->
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'

export default {
  name: 'Stats',
  data: function(){
    return {
      lang: 'en',
      animationclass: "fl-scrolling",
      date: new Date(),
    }
  },
  timer: 0,
  created() {
    this.$options.timer = setInterval(()=>{
      this.date = new Date()
    }, 1000)
  },
  destroyed() {
      clearInterval(this.$options.timer);
    },
  methods: { 
    getleage(){
      if(this.$store.state.game.Week == 1){
        return {league: this.$store.state.game.League-1, week: 38}
      }else{
         return {league: this.$store.state.game.League, week: this.$store.state.game.Week-1}
      }
    },
    getteams(team){
      let result = this.$store.state.teams.filter(item => item.id == team);
      return result[0].Abriviation
    },
    getimg(name){
      if(name == null) return
      if(this.$store.state.teams == null) return
      let result = this.$store.state.teams.filter(item => item.id == name);
      if(result[0].Icon != ""){
        return "https://champs-admin.info/gallery/" + result[0].Icon
      }
    },
    
  }
};
</script>-->

<style>
@-webkit-keyframes move_eye { from { left: 1270px; } to { left: -2850px; }  }
@keyframes move_eye { from { left: 1270px; } to { left: -2850px; }  }

@-webkit-keyframes scroll { from { left: 1270px; } to { left: -2800px; }  }
@keyframes scroll { from { left: 1270px; } to { left: -2800px; }  }

.fl-scrolling {
  -webkit-animation: 24s linear 0s infinite move_eye;
          animation: 24s linear 0s infinite move_eye;
}

.fl-scrollings {
  -webkit-animation: 24s linear 0s infinite scroll;
          animation: 24s linear 0s infinite scroll;
}
</style>